import { Injectable } from '@angular/core';
import { AppSettings } from './app.settings';
import { TokenStorageService } from './token-storage.service';
@Injectable({
  providedIn: 'root'
})
export class HelperService {

  preloader: boolean = false;

  constructor(private tokenStorageService: TokenStorageService) { }

  public contains(list: any, key: any) {
    return list.indexOf(key) > -1;
  }
  convert(str:any, format: any) {
    var date = new Date(str),
      mnth = ("0" + (date.getMonth() + 1)).slice(-2),
      day = ("0" + date.getDate()).slice(-2);
      let val = '';
      switch(format) {
        case AppSettings.MM_DD_YYYY:
          val = [mnth, day, date.getFullYear()].join("-");
          break;
        case AppSettings.DD_MM_YYYY:
          val = [day, mnth, date.getFullYear()].join("-");
          break;
        case AppSettings.YYYY_MM_DD:
          val = [date.getFullYear(), mnth, day].join("-");
          break;
      }
    return val;
  }
  isActionAllowed(module: string, action: string) {
    let userRole = this.tokenStorageService.getUserRole();
    let moduleMap: any = AppSettings.USER_ROLE_ACTION_MAP;
    let allowedActionsList = moduleMap[module][userRole], allowed = false;
    if(allowedActionsList?.length) {
      allowed = allowedActionsList.includes(action);
    }
    return allowed;
  }
  isAdminUser() {
    return this.tokenStorageService.getUserRole()?.toUpperCase() == AppSettings.USER_ROLES.ADMIN;
  }
  showLoader(val: boolean) {
    this.preloader = val;
  }
  getControlButtons(module: string, role: string, removeKeys: any, list: any, conditions: any = {}) {
    let actions: any;
    actions = AppSettings.USER_ROLE_ACTION_MAP[module as keyof object][AppSettings.USER_ROLES[role as keyof object]];
    let state = Object.keys(conditions).length;
    let canBeDisabled = false;
    actions.forEach((rec: any) => {
      canBeDisabled = state ? conditions[rec] ? true : false : false;
      list.push({
        "title": AppSettings.ACTION_TITLE[rec as keyof object],
        "icon": AppSettings.ACTION_ICONS[rec as keyof object],
        "action": AppSettings[rec as keyof object],
        "canBeDisabled": canBeDisabled,
        "disabledField": canBeDisabled ? conditions[rec].disabledField : '',
        "disabledTitle": AppSettings.ACTION_TITLE[`${rec}_DISABLE` as keyof object]
      });
    });
    removeKeys.forEach((rec: any) => {
      this.removeObject(list, rec);
    });
  }
  removeObject(list: any, key: string) {
    let index = list.findIndex((rec:any) => {
      return rec.action == key;
    });
    if(index > -1) {
      list.splice(index, 1);
    }
  }
  
  calculateCost(modulesTobeCharged: any, priceList: any, userCount: number) :number{
    let cost = 0;
    if(modulesTobeCharged?.length && priceList?.length) {
      modulesTobeCharged.forEach((rec: any) => {
        let costObj = priceList.find((price: any) => {
          return price.item == rec;
        });
        if(costObj) {
          if(costObj.item.includes(AppSettings.COST_MODULE_MAP.USERS)) {
            cost += costObj.itemCost * userCount;
          } else {
            cost+= costObj.itemCost;
          }
        }
      })
    }
    return cost;
  }
  isModulePresent(list: any, module: string): boolean {
    if(!list?.length || !module) {
      return false;
    }
    let obj: any = list.filter((rec: any) => {
      rec.includes(module);
    });
    if(obj) {
      return true;
    }
    return false;
  }
  removeModule(list: any, module: string) {
    if(!list?.length || !module) {
      return;
    }
    let index = list.findIndex((rec: any) => {
      return rec.includes(module);
    });
    if(index > -1) {
      list.splice(index, 1);
    }
  }
  extractCostRange(key: string) {
    if(!key) {
      return [0, 0];
    }
    let ele = key.split("_");
    let length = ele.length;
    if(length && length >= 3) {
      return [Number(ele[length - 2]), Number(ele[length - 1])];
    }
    return [0,0];
  }
  getUserPricingKey(list: any, userCount: number): string {
    if(!list?.length || userCount < 1) {
      return '';
    }
    let userList: any = list.filter((rec: any) => {
      return rec.item.includes(AppSettings.COST_MODULE_MAP.USERS);
    });
    if(userList?.length) {
      let length = userList.length, range: any = [];
      for(let i = 0; i < length; i++) {
        range = this.extractCostRange(userList[i].item);
        if(range?.length == 2) {
          if(userCount >= range[0] && userCount <= range [1]) {
            return userList[i].item;
          }
        }
      }
    }
    return '';
  }
  isRouteAllowed(route: string) {
    route = route.replace("/", "");
    let module = AppSettings.ROUTE_MODULE_MAP[route as keyof object];
    let action = AppSettings.ACTIONS.VIEW;
    return this.isActionAllowed(module, action);
  }

  isValidEmail(email: string) {
    if(!email?.trim()) {
      return false;
    }
    let regEx = /^[_a-zA-Z0-9]+(\.[_a-zA-Z0-9]+)*@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*(\.[a-zA-Z]{2,4})$/;
    return regEx.test(email);
  }
  isValidUserName(userName: string) {
    let regEx = /(^[a-z])+([a-z0-9_])+([a-z0-9_]{4,}$)/i;
    if (userName?.length > 50 || !userName?.trim()) {
      // this.showValidationError('userName');
      return false;
    }
    // if(!regEx.test(userName)) {
    //   this.showValidationError('userName');
    //   return false;
    // }
    return regEx.test(userName);
  }
  isValidPassword(password: string, confirmpassword: string) {
    var PWD_REGEX = /((?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%_\-*&(){}?]).{8,16})/i;
    var matchRegEx = PWD_REGEX.test(password);
    if(!password?.trim()) {
      return 'empty';
    }
    if (password?.length < 8 || password?.length > 16) {
      // this.showValidationError('password_length');
      return 'password_length';
    }
    if(matchRegEx == false) {
      // this.showValidationError('password_regex');
      return 'password_regex';
    }
    if(password != confirmpassword) {
      // this.showValidationError('password');
      return 'password';
    }
    return true;
  }
}
